export const RECENT_TRIPS_PER_PAGE = 12
export const UPCOMING_TRIPS_PER_PAGE = 6
export const NAV_TRIPS_PER_PAGE = 5
